import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  trips: [],
  loading: false,
  error: null,
  pagination: {
    totalPages: 0,
    totalElements: 0,
    currentPage: 0,
    pageSize: 10,
    isLastPage: false,
    isFirstPage: true,
  },
  billChargedTrips: [],
billChargedPagination: {
  totalPages: 0,
  totalElements: 0,
  currentPage: 0,
  pageSize: 10,
  isLastPage: false,
  isFirstPage: true,
},
};

const tripSlice = createSlice({
  name: "trip",
  initialState,
  reducers: {
    fetchTripsStart(state) {
      state.loading = false;
      state.error = null;
    },
    fetchTripsSuccess(state, action) {
      state.trips = action.payload.trips;
      state.pagination = action.payload.pagination;
      state.loading = false;
      state.error = null;
    },
    fetchTripsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
fetchBillChargedTripsStart(state) {
  state.loading = true;
  state.error = null;
},

fetchBillChargedTripsSuccess(state, action) {
  state.billChargedTrips = action.payload.trips;
  state.billChargedPagination = action.payload.pagination;
  state.loading = false;
  state.error = null;
},

fetchBillChargedTripsFailure(state, action) {
  state.loading = false;
  state.error = action.payload;
},
    addBookedTripStart(state) {
      state.loading = true;
      state.error = null;
    },
    addBookedTripSuccess(state, action) {
      state.loading = false;
      state.trips.unshift(action.payload);
      state.error = null;
    },
    addBookedTripFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    deleteBookedTripStart(state) {
      state.loading = true;
      state.error = null;
    },
    deleteBookedTripSuccess(state, action) {
      state.loading = false;
      state.trips = state.trips.filter((trip) => trip.id !== action.payload);
      state.error = null;
    },
    deleteBookedTripFailure(state, action) {
      state.loading = true;
      state.error = action.payload;
    },
    editBookedTripStart(state) {
      state.loading = true;
      state.error = null;
    },
    editBookedTripSuccess(state, action) {
      state.loading = false;
      const updatedTrip = action.payload;
      const index = state.trips.findIndex((trip) => trip.id === updatedTrip.id);
      if (index !== -1) {
        state.trips[index] = updatedTrip;
      }
      state.error = null;
    },
    editBookedTripFailure(state, action) {
      state.loading = true;
      state.error = action.payload;
    },

    // getCategoryByIdStart(state) {
    //   state.loading = false;
    //   state.error = null;
    //   state.selectedCategory = null;
    // },
    // getCategoryByIdSuccess(state, action) {
    //   state.loading = false;
    //   state.selectedCategory = action.payload;
    //   state.error = null;
    // },
    // getCategoryByIdFailure(state, action) {
    //   state.loading = false;
    //   state.error = action.payload;
    // },
    resetTrips(state) {
      state.trips = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  fetchTripsStart,
  fetchTripsSuccess,
  fetchTripsFailure,
  addBookedTripStart,
  addBookedTripSuccess,
  addBookedTripFailure,
  deleteBookedTripStart,
  deleteBookedTripSuccess,
  deleteBookedTripFailure,
  editBookedTripStart,
  editBookedTripSuccess,
  editBookedTripFailure,
  //   getCategoryByIdFailure,
  //   getCategoryByIdStart,
  //   getCategoryByIdSuccess,
  resetTrips,
  fetchBillChargedTripsStart,
fetchBillChargedTripsSuccess,
fetchBillChargedTripsFailure,
} = tripSlice.actions;

export default tripSlice.reducer;
